import React from 'react';
import RealTimeBonanzaProgressTracker from '../components/user/RealTimeBonanzaProgressTracker';

const BonanzaTracker = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8">
      <RealTimeBonanzaProgressTracker />
    </div>
  );
};

export default BonanzaTracker;
